import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_TRIGGER } from "./gql";

const useTriggerStack = createDefaultMutationHook(STACK_TRIGGER);
export const useBulkTriggerStack = createBulkMutationHook(STACK_TRIGGER);

export default useTriggerStack;
